<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">资产类别</span>
            <span class="bar-tools">
                <input type="text" class="h-input h-input-s" style="width:180px" placeholder="请输入编码或名称"
                       v-model="keyword" @keyup.enter="loadList">
                <Button size="s" @click="loadList">查询</Button>
                <Button color="primary" size="s" @click="add">新增</Button>
                <Button size="s" @click="exportCsv">导出</Button>
                <Button size="s" @click="printPage">打印</Button>
            </span>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:140px">资产类别编码</th>
                    <th style="min-width:160px">资产类别名称</th>
                    <th style="width:120px">折旧方法</th>
                    <th style="width:100px">使用期限</th>
                    <th style="width:90px">残值率</th>
                    <th style="width:180px">固定资产科目</th>
                    <th style="width:180px">累计折旧科目</th>
                    <th style="min-width:120px">备注</th>
                    <th style="width:110px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td>{{item.code}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.depreciationMethod}}</td>
                    <td align="right">{{item.useLife}}</td>
                    <td align="right">{{item.residualRate}} %</td>
                    <td>{{item.assetSubjectName}}</td>
                    <td>{{item.depSubjectName}}</td>
                    <td>{{item.remark}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="9" class="text-center padding">暂无数据</td>
                </tr>
                </tbody>
            </table>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id ? '编辑' : '新增'}}资产类别</div>
            <Form ref="form" v-width="450" :labelWidth="120" :model="form" :rules="validationRules">
                <FormItem label="编码" prop="code"><input type="text" v-model="form.code"></FormItem>
                <FormItem label="名称" prop="name"><input type="text" v-model="form.name"></FormItem>
                <FormItem label="折旧方法">
                    <Select v-model="form.depreciationMethod" :datas="depMethods" :deletable="false"></Select>
                </FormItem>
                <FormItem label="固定资产科目">
                    <Select v-model="form.assetSubjectId" :datas="subjectOptions" keyName="id" titleName="name"
                            :deletable="false" @change="onSubjectChange('asset', $event)"></Select>
                </FormItem>
                <FormItem label="使用期限" prop="useLife">
                    <NumberInput v-model="form.useLife" :min="1"></NumberInput>
                </FormItem>
                <FormItem label="残值率" prop="residualRate">
                    <NumberInput v-model="form.residualRate" :precision="2" :min="0" :max="100"></NumberInput>
                </FormItem>
                <FormItem label="累计折旧科目">
                    <Select v-model="form.depSubjectId" :datas="subjectOptions" keyName="id" titleName="name"
                            :deletable="false" @change="onSubjectChange('dep', $event)"></Select>
                </FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit" :loading="loading">{{form.id ? '更新' : '保存'}}</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>
    </app-content>
</template>

<script>
const emptyForm = {
    id: null, code: '', name: '', depreciationMethod: '平均年限法',
    useLife: 60, residualRate: 5,
    assetSubjectId: null, assetSubjectCode: '', assetSubjectName: '',
    depSubjectId: null, depSubjectCode: '', depSubjectName: '',
    remark: ''
};

export default {
    name: 'AssetsType',
    data() {
        return {
            datas: [],
            keyword: '',
            showForm: false,
            loading: false,
            form: Object.assign({}, emptyForm),
            subjectOptions: [],
            depMethods: ['平均年限法', '不计提折旧'],
            validationRules: { required: ['code', 'name', 'useLife', 'residualRate'] }
        };
    },
    watch: {
        showForm(val) { if (!val) this.form = Object.assign({}, emptyForm); }
    },
    methods: {
        loadSubjects() {
            this.$api.assets.assets.options().then(({ data }) => {
                this.subjectOptions = (data.subjects || []).map(s => ({ id: s.id, code: s.code, name: s.code ? `${s.code} ${s.name}` : s.name }));
            });
        },
        loadList() {
            this.$api.assets.assetsType.list({ keyword: this.keyword }).then(({ data }) => {
                this.datas = data || [];
            });
        },
        onSubjectChange(field, id) {
            const s = this.subjectOptions.find(o => o.id === id);
            if (!s) return;
            if (field === 'asset') {
                this.form.assetSubjectCode = s.code;
                this.form.assetSubjectName = s.name;
            } else {
                this.form.depSubjectCode = s.code;
                this.form.depSubjectName = s.name;
            }
        },
        add() { this.form = Object.assign({}, emptyForm); this.showForm = true; },
        edit(item) { this.form = Object.assign({}, emptyForm, item); this.showForm = true; },
        submit() {
            if (!this.$refs.form.valid().result) return;
            this.loading = true;
            this.$api.assets.assetsType[this.form.id ? 'update' : 'save'](this.form).then(() => {
                this.loading = false;
                this.showForm = false;
                this.loadList();
                this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm(`确认删除「${item.name}」?`).then(() => {
                this.$api.assets.assetsType.delete(item.id).then(() => this.loadList());
            });
        },
        exportCsv() {
            const head = ['资产类别编码', '资产类别名称', '折旧方法', '使用期限', '残值率', '固定资产科目', '累计折旧科目', '备注'];
            const keys = ['code', 'name', 'depreciationMethod', 'useLife', 'residualRate', 'assetSubjectName', 'depSubjectName', 'remark'];
            const rows = this.datas.map(d => keys.map(k => (k === 'residualRate' ? (d[k] == null ? '' : d[k] + ' %') : d[k])));
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`资产类别_${new Date().toISOString().slice(0, 10)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); }
    },
    mounted() {
        this.loadSubjects();
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .bar-tools {
        margin-left: 20px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .grid {
        width: 100%;
        border-collapse: collapse;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }
    }

    .actions span {
        margin-right: 8px;
        cursor: pointer;
        color: #3b91ff;
    }
</style>
